import React from "react";
import ReactGA from "react-ga4";
import { useAuth } from "./AuthContext";

const GAContext = React.createContext(null);

export const GAProvider = props => {
  const user = useAuth();
  ReactGA.initialize(window.GA_TRACKER);
  if (user && user.profile) {
    ReactGA.set({ userId: user.profile.id });

    ReactGA.set({
      user_properties: {
        company: user.is_staff
          ? "OpenSlate"
          : user.profile.subscription
          ? user.profile.subscription.name
          : "unknown"
      }
    });
  }
  return <GAContext.Provider value={ReactGA} {...props} />;
};

export const useGoogleAnalytics = () => {
  const context = React.useContext(GAContext);
  if (context === undefined || context === null) {
    throw new Error(`useGAContext must be used within a GAProvider`);
  }
  return context;
};
